import script from "./WebinarIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarIndex.vue?vue&type=script&setup=true&lang=js"

import "./WebinarIndex.vue?vue&type=style&index=0&id=309d12ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309d12ee"]])

export default __exports__